import React from 'react';
import axios from 'axios';
import { useAlerts } from 'components/Alerts';

const UnsubscribeButton = ({
  unsubscribePath,
  label
}) => {
  const alerts = useAlerts();

  const unsubscribe = () => {
    axios.post(unsubscribePath)
      .then(() => {
        window.location.href = `${window.location.protocol}//${window.location.host}${location.pathname}?unsubscribed`;
      })
      .catch(() => {
        alerts.error('Could not unsubscribe from this project');
      });
  };

  return (
    <a
      href="##"
      role="button"
      onClick={() => { unsubscribe(); }}
    >
      {label}
    </a>
  );
};

export default UnsubscribeButton;
